import { byPosition } from './comparators/by-position';
const constructOptionByValue = (options)=>{
    const obj = {};
    const inactiveOptionByValue = (value)=>options.find((o)=>o.value === value);
    options.forEach((x)=>{
        if (x.active !== false) {
            obj[x.value] = x;
        } else {
            // this is done because we are not sure if there can be a case where 2 object can have the same value, 1 with active as false, and 1 with true
            // Mostly this shouldn't be the case, and we can remove this part, but just to be on the safer side
            obj[x.value] = inactiveOptionByValue(x.value);
        }
    });
    return obj;
};
export const FieldHelper = (field)=>{
    const metaData = field === null || field === void 0 ? void 0 : field.metaData;
    const activeOptions = (()=>{
        var _ref;
        return ((_ref = metaData === null || metaData === void 0 ? void 0 : metaData.options) !== null && _ref !== void 0 ? _ref : []).filter(({ active })=>{
            return active;
        }).sort(byPosition);
    })();
    const allOptions = (()=>{
        var _Object_values;
        const options = metaData === null || metaData === void 0 ? void 0 : metaData.options;
        const byValue = constructOptionByValue(options !== null && options !== void 0 ? options : []);
        const nonDuplicateOptions = (_Object_values = Object.values(byValue)) !== null && _Object_values !== void 0 ? _Object_values : [];
        return nonDuplicateOptions.sort(byPosition);
    })();
    const originalOptions = (()=>{
        return metaData === null || metaData === void 0 ? void 0 : metaData.options;
    })();
    return {
        options: {
            activeOptions,
            allOptions,
            originalOptions
        }
    };
};
